import axios from 'axios';
import { EventEmitter } from 'eventemitter3';
import store from '../store';
import { API_URL } from '../../config/config';

export default class Request {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new Request());
	}

	constructor() {
		this.deniedRequests = [];
		this.events = new EventEmitter();
	}

	redoDenied() {
		if (store.state.authData.isDifferentUser) {
			window.location.reload();
			return;
		}

		this.deniedRequests
			.forEach(r => {
				r.cbk(this.doRequest.apply(this, r.args));
			});
		this.deniedRequests.length = 0;
	}

	getAxios(url) {
		var options = {};
		if (!/\/public\//.test(url) && store.state.authData.tokenData) {
			options.headers = {
				Authorization: 'Bearer ' + store.state.authData.tokenData.token
			};
		}
		return axios.create(options);
	}

	doRequest(method, url, data, params) {
		return new Promise((r, rj) => {
			this.execRequest(method, url, data, params)
				.then(result => {
					r(result);
				})
				.catch(e => {
					if (e.response && e.response.status == 401) {
						this.deniedRequests.push({ cbk: r, args: [method, url, data, params] });
						this.events.emit('expire');
					} else {
						rj(e);
					}
				});
		});
	}

	execRequest(method, url, data, params) {
		if (method === 'get') {
			return this.getAxios(url)[method](url, { params });
		} else {
			return this.getAxios(url)[method](url, data, { params });
		}
	}

	getUrl(path) {
		if (/^http/.test(path)) {
			return path;
		}
		return API_URL + path;
	}

	get(path, params) {
		return this.doRequest('get', this.getUrl(path), null, params);
	}

	put(path, data, params) {
		return this.doRequest('put', this.getUrl(path), data, params);
	}

	post(path, data, params) {
		return this.doRequest('post', this.getUrl(path), data, params);
	}

	delete(path, data, params) {
		return this.doRequest('delete', this.getUrl(path), data, params);
	}

}
